import { render, staticRenderFns } from "./BaseInputNumber.vue?vue&type=template&id=2417874e"
import script from "./BaseInputNumber.vue?vue&type=script&lang=js"
export * from "./BaseInputNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports